<agpr-panel header="Briefing.canvas.customize.theme">
    <div class="agpr-briefingCanvasCustomize-colorLabel">
        {{ 'Briefing.canvas.customize.brandColor' | localize }}
    </div>
    <div class="agpr-briefingCanvasCustomize-colorPicker">
        <agpr-color-picker-field
            [value]="canvasPreview.accentColor"
            (changes)="accentColorChanged($event)"
        ></agpr-color-picker-field>
    </div>
</agpr-panel>
<agpr-panel header="Briefing.onlineBriefing.settings.bannerStyle">
    <div class="agpr-briefingCanvasCustomize-bannerStyleContainer" role="radiogroup">
        <button
            class="agpr-briefingCanvasCustomize-bannerStyleButton"
            [class.agpr-briefingCanvasCustomize-bannerStyleButton--selected]="canvasPreview.bannerStyle === bannerStyleEnum.SIMPLE"
            (click)="bannerStyleChanged(bannerStyleEnum.SIMPLE)"
            role="radio"
            [attr.aria-checked]="canvasPreview.bannerStyle === bannerStyleEnum.SIMPLE"
        >
            <img
                class="agpr-briefingCanvasCustomize-bannerStyleImage"
                [src]="appBaseHref + 'assets/images/online_briefing_frame_style_simple.svg'"
                alt=""
            />
            <span>{{ 'Briefing.canvas.customize.bannerStyle.noFrame' | localize }}</span>
        </button>
        <button
            class="agpr-briefingCanvasCustomize-bannerStyleButton"
            [class.agpr-briefingCanvasCustomize-bannerStyleButton--selected]="canvasPreview.bannerStyle === bannerStyleEnum.IMAGE_GRID"
            (click)="bannerStyleChanged(bannerStyleEnum.IMAGE_GRID)"
            role="radio"
            [attr.aria-checked]="canvasPreview.bannerStyle === bannerStyleEnum.IMAGE_GRID"
        >
            <img
                class="agpr-briefingCanvasCustomize-bannerStyleImage"
                [src]="appBaseHref + 'assets/images/online_briefing_frame_style_image_grid.svg'"
                alt=""
            />
            <span>{{ 'Briefing.canvas.customize.bannerStyle.collage' | localize }}</span>
        </button>
    </div>
</agpr-panel>
